var vector = require('./lib/vector');
var factor = require('./lib/factor');
var matrix = require('./lib/matrix');
var t = require('./lib/t');
var misc = require('./lib/misc');
var distributions = require('./lib/distributions');
var regression = require('./lib/regression');
var correlation = require('./lib/correlation');
var numeric = require('./lib/numeric');
var anova = require('./lib/anova');
var normality = require('./lib/normality');
var confidence = require('./lib/confidence');
var power = require('./lib/power');
var nonparametric = require('./lib/nonparametric');

module.exports.Vector = vector.Vector;
module.exports.Factor = factor.Factor;
module.exports.Matrix = factor.Matrix;
module.exports.Sequence = vector.Sequence;
module.exports.StudentT = t.StudentT;
module.exports.Misc = misc.Misc;
module.exports.Numeric = numeric.Numeric;
module.exports.Normal = distributions.Normal;
module.exports.StandardNormal = distributions.StandardNormal;
module.exports.T = distributions.T;
module.exports.F = distributions.F;
module.exports.Kolmogorov = distributions.Kolmogorov;
module.exports.Regression = regression.Regression;
module.exports.Correlation = correlation.Correlation;
module.exports.Anova = anova.Anova;
module.exports.Normality = normality.Normality;
module.exports.Confidence = confidence.Confidence;
module.exports.Power = power.Power;
module.exports.Nonparametric = nonparametric.Nonparametric;
